import React from 'react';
import {Form} from '@themesberg/react-bootstrap';

export default (props) => {
  const {id, disabled, onChange, value, intl} = props;
  if (intl.locale === 'fr') {
    return (
      <Form.Select id={id} defaultValue="FR" onChange={onChange} disabled={disabled} value={value}>
        <option value="AF">Afghanistan</option>
        <option value="ZA">Afrique du Sud</option>
        <option value="AL">Albanie</option>
        <option value="DZ">Algérie</option>
        <option value="DE">Allemagne</option>
        <option value="MK">Ancienne République yougoslave de Macédoine</option>
        <option value="AD">Andorre</option>
        <option value="AO">Angola</option>
        <option value="AI">Anguilla</option>
        <option value="AQ">Antarctique</option>
        <option value="AG">Antigua-et-Barbuda</option>
        <option value="AN">Antilles néerlandaises</option>
        <option value="SA">Arabie saoudite</option>
        <option value="AR">Argentine</option>
        <option value="AM">Arménie</option>
        <option value="AW">Aruba</option>
        <option value="AU">Australie</option>
        <option value="AT">Autriche</option>
        <option value="AZ">Azerbaïdjan</option>
        <option value="BS">Bahamas</option>
        <option value="BH">Bahreïn</option>
        <option value="BD">Bangladesh</option>
        <option value="BB">Barbade</option>
        <option value="BE">Belgique</option>
        <option value="BZ">Belize</option>
        <option value="BJ">Bénin</option>
        <option value="BM">Bermudes</option>
        <option value="BT">Bhoutan</option>
        <option value="BY">Biélorussie</option>
        <option value="BO">Bolivie</option>
        <option value="BA">Bosnie-et-Herzégovine</option>
        <option value="BW">Botswana</option>
        <option value="BR">Brésil</option>
        <option value="BN">Brunei Darussalam</option>
        <option value="BG">Bulgarie</option>
        <option value="BF">Burkina Faso</option>
        <option value="BI">Burundi</option>
        <option value="KH">Cambodge</option>
        <option value="CM">Cameroun</option>
        <option value="CA">Canada</option>
        <option value="CV">Cap-Vert</option>
        <option value="CL">Chili</option>
        <option value="CN">Chine</option>
        <option value="CY">Chypre</option>
        <option value="CO">Colombie</option>
        <option value="KM">Comores</option>
        <option value="CG">Congo</option>
        <option value="CR">Costa Rica</option>
        <option value="CI">Côte d'Ivoire</option>
        <option value="HR">Croatie</option>
        <option value="CU">Cuba</option>
        <option value="DK">Danemark</option>
        <option value="DJ">Djibouti</option>
        <option value="DM">Dominique</option>
        <option value="EG">Égypte</option>
        <option value="SV">El Salvador</option>
        <option value="AE">Émirats arabes unis</option>
        <option value="EC">Équateur</option>
        <option value="ER">Érythrée</option>
        <option value="ES">Espagne</option>
        <option value="EE">Estonie</option>
        <option value="FM">États fédérés de Micronésie</option>
        <option value="US">États-Unis</option>
        <option value="ET">Éthiopie</option>
        <option value="FJ">Fidji</option>
        <option value="FI">Finlande</option>
        <option value="FR">France</option>
        <option value="GA">Gabon</option>
        <option value="GM">Gambie</option>
        <option value="GE">Géorgie</option>
        <option value="GS">Géorgie du Sud-et-les Îles Sandwich du Sud</option>
        <option value="GH">Ghana</option>
        <option value="GI">Gibraltar</option>
        <option value="GR">Grèce</option>
        <option value="GD">Grenade</option>
        <option value="GL">Groenland</option>
        <option value="GP">Guadeloupe</option>
        <option value="GU">Guam</option>
        <option value="GT">Guatemala</option>
        <option value="GN">Guinée</option>
        <option value="GQ">Guinée équatoriale</option>
        <option value="GW">Guinée-Bissau</option>
        <option value="GY">Guyane</option>
        <option value="GF">Guyane française</option>
        <option value="HT">Haïti</option>
        <option value="HN">Honduras</option>
        <option value="HK">Hong Kong</option>
        <option value="HU">Hongrie</option>
        <option value="BV">Ile Bouvet</option>
        <option value="CX">Ile Christmas</option>
        <option value="NF">Île Norfolk</option>
        <option value="PN">Île Pitcairn</option>
        <option value="AX">Iles Aland</option>
        <option value="KY">Iles Cayman</option>
        <option value="CC">Iles Cocos (Keeling)</option>
        <option value="CK">Iles Cook</option>
        <option value="FO">Îles Féroé</option>
        <option value="HM">Îles Heard-et-MacDonald</option>
        <option value="FK">Îles Malouines</option>
        <option value="MP">Îles Mariannes du Nord</option>
        <option value="MH">Îles Marshall</option>
        <option value="UM">Îles mineures éloignées des États-Unis</option>
        <option value="SB">Îles Salomon</option>
        <option value="TC">Îles Turques-et-Caïques</option>
        <option value="VG">Îles Vierges britanniques</option>
        <option value="VI">Îles Vierges des États-Unis</option>
        <option value="IN">Inde</option>
        <option value="ID">Indonésie</option>
        <option value="IQ">Iraq</option>
        <option value="IE">Irlande</option>
        <option value="IS">Islande</option>
        <option value="IL">Israël</option>
        <option value="IT">Italie</option>
        <option value="LY">Jamahiriya arabe libyenne</option>
        <option value="JM">Jamaïque</option>
        <option value="JP">Japon</option>
        <option value="JO">Jordanie</option>
        <option value="KZ">Kazakhstan</option>
        <option value="KE">Kenya</option>
        <option value="KG">Kirghizistan</option>
        <option value="KI">Kiribati</option>
        <option value="KW">Koweït</option>
        <option value="LS">Lesotho</option>
        <option value="LV">Lettonie</option>
        <option value="LB">Liban</option>
        <option value="LR">Libéria</option>
        <option value="LI">Liechtenstein</option>
        <option value="LT">Lituanie</option>
        <option value="LU">Luxembourg</option>
        <option value="MO">Macao</option>
        <option value="MG">Madagascar</option>
        <option value="MY">Malaisie</option>
        <option value="MW">Malawi</option>
        <option value="MV">Maldives</option>
        <option value="ML">Mali</option>
        <option value="MT">Malte</option>
        <option value="MA">Maroc</option>
        <option value="MQ">Martinique</option>
        <option value="MU">Maurice</option>
        <option value="MR">Mauritanie</option>
        <option value="YT">Mayotte</option>
        <option value="MX">Mexique</option>
        <option value="MC">Monaco</option>
        <option value="MN">Mongolie</option>
        <option value="MS">Montserrat</option>
        <option value="MZ">Mozambique</option>
        <option value="MM">Myanmar</option>
        <option value="NA">Namibie</option>
        <option value="NR">Nauru</option>
        <option value="NP">Népal</option>
        <option value="NI">Nicaragua</option>
        <option value="NE">Niger</option>
        <option value="NG">Nigéria</option>
        <option value="NU">Niué</option>
        <option value="NO">Norvège</option>
        <option value="NC">Nouvelle-Calédonie</option>
        <option value="NZ">Nouvelle-Zélande</option>
        <option value="OM">Oman</option>
        <option value="UG">Ouganda</option>
        <option value="UZ">Ouzbékistan</option>
        <option value="PK">Pakistan</option>
        <option value="PW">Palaos</option>
        <option value="PA">Panama</option>
        <option value="PG">Papouasie-Nouvelle-Guinée</option>
        <option value="PY">Paraguay</option>
        <option value="NL">Pays-Bas</option>
        <option value="PE">Pérou</option>
        <option value="PH">Philippines</option>
        <option value="PL">Pologne</option>
        <option value="PF">Polynésie française</option>
        <option value="PR">Porto Rico</option>
        <option value="PT">Portugal</option>
        <option value="TW">Province chinoise de Taiwan</option>
        <option value="QA">Qatar</option>
        <option value="SY">République arabe syrienne</option>
        <option value="CF">République centrafricaine</option>
        <option value="KR">République de Corée</option>
        <option value="MD">République de Moldavie</option>
        <option value="CD">République démocratique du Congo</option>
        <option value="DO">République dominicaine</option>
        <option value="IR">République islamique d'Iran</option>
        <option value="KP">République populaire démocratique de Corée</option>
        <option value="LA">République Populaire du Laos</option>
        <option value="CZ">République tchèque</option>
        <option value="TZ">République-Unie de Tanzanie</option>
        <option value="RE">Réunion</option>
        <option value="RO">Roumanie</option>
        <option value="GB">Royaume-Uni</option>
        <option value="RU">Russie</option>
        <option value="RW">Rwanda</option>
        <option value="EH">Sahara occidental</option>
        <option value="KN">Saint-Christophe-et-Niévès</option>
        <option value="SM">Saint-Marin</option>
        <option value="PM">Saint-Pierre-et-Miquelon</option>
        <option value="VA">Saint-Siège (Cité du Vatican)</option>
        <option value="VC">Saint-Vincent-et-les Grenadines</option>
        <option value="SH">Sainte-Hélène</option>
        <option value="LC">Sainte-Lucie</option>
        <option value="WS">Samoa</option>
        <option value="AS">Samoa américaines</option>
        <option value="ST">Sao Tomé-et-Principe</option>
        <option value="SN">Sénégal</option>
        <option value="CS">Serbie-et-Monténégro</option>
        <option value="SC">Seychelles</option>
        <option value="SL">Sierra Leone</option>
        <option value="SG">Singapour</option>
        <option value="SK">Slovaquie</option>
        <option value="SI">Slovénie</option>
        <option value="SO">Somalie</option>
        <option value="SD">Soudan</option>
        <option value="LK">Sri Lanka</option>
        <option value="SE">Suède</option>
        <option value="CH">Suisse</option>
        <option value="SR">Suriname</option>
        <option value="SJ">Svalbard et Jan Mayen</option>
        <option value="SZ">Swaziland</option>
        <option value="TJ">Tadjikistan</option>
        <option value="TD">Tchad</option>
        <option value="IO">Territoire britannique de l'océan Indien</option>
        <option value="TF">Territoire Francais du Sud</option>
        <option value="PS">Territoires palestiniens occupés</option>
        <option value="TH">Thaïlande</option>
        <option value="TL">Timor oriental</option>
        <option value="TG">Togo</option>
        <option value="TK">Tokelau</option>
        <option value="TO">Tonga</option>
        <option value="TT">Trinité-et-Tobago</option>
        <option value="TN">Tunisie</option>
        <option value="TM">Turkménistan</option>
        <option value="TR">Turquie</option>
        <option value="TV">Tuvalu</option>
        <option value="UA">Ukraine</option>
        <option value="UY">Uruguay</option>
        <option value="VU">Vanuatu</option>
        <option value="VE">Vénézuéla</option>
        <option value="VN">Vietnam</option>
        <option value="WF">Wallis-et-Futuna</option>
        <option value="YE">Yémen</option>
        <option value="ZM">Zambie</option>
        <option value="ZW">Zimbabwe</option>
      </Form.Select>
    );
  } else {
    return (
      <Form.Select id={id} defaultValue="US" onChange={onChange} disabled={disabled} value={value}>
        <option value="AF">Afghanistan</option>
        <option value="AL">Albania</option>
        <option value="DZ">Algeria</option>
        <option value="AD">Andorra</option>
        <option value="AO">Angola</option>
        <option value="AI">Anguilla</option>
        <option value="AQ">Antarctica</option>
        <option value="AG">Antigua and Barbuda</option>
        <option value="AR">Argentina</option>
        <option value="AM">Armenia</option>
        <option value="AW">Aruba</option>
        <option value="AU">Australia</option>
        <option value="AT">Austria</option>
        <option value="AZ">Azerbaijan</option>
        <option value="BS">Bahamas</option>
        <option value="BH">Bahrain</option>
        <option value="BD">Bangladesh</option>
        <option value="BB">Barbados</option>
        <option value="BY">Belarus</option>
        <option value="BE">Belgium</option>
        <option value="BZ">Belize</option>
        <option value="BJ">Benin</option>
        <option value="BM">Bermuda</option>
        <option value="BT">Bhutan</option>
        <option value="BO">Bolivia</option>
        <option value="BA">Bosnia and Herzegovina</option>
        <option value="BW">Botswana</option>
        <option value="BR">Brazil</option>
        <option value="BN">Brunei Darussalam</option>
        <option value="BG">Bulgaria</option>
        <option value="BF">Burkina Faso</option>
        <option value="BI">Burundi</option>
        <option value="KH">Cambodia</option>
        <option value="CM">Cameroon</option>
        <option value="CA">Canada</option>
        <option value="CV">Cape Verde</option>
        <option value="KY">Cayman Islands</option>
        <option value="CF">Central African Republic</option>
        <option value="TD">Chad</option>
        <option value="CL">Chile</option>
        <option value="CN">China</option>
        <option value="CO">Colombia</option>
        <option value="KM">Comoros</option>
        <option value="CG">Congo</option>
        <option value="CR">Costa Rica</option>
        <option value="HR">Croatia</option>
        <option value="CU">Cuba</option>
        <option value="CY">Cyprus</option>
        <option value="CZ">Czech Republic</option>
        <option value="DK">Denmark</option>
        <option value="DJ">Djibouti</option>
        <option value="DM">Dominica</option>
        <option value="DO">Dominican Republic</option>
        <option value="EC">Ecuador</option>
        <option value="EG">Egypt</option>
        <option value="SV">El Salvador</option>
        <option value="GQ">Equatorial Guinea</option>
        <option value="ER">Eritrea</option>
        <option value="EE">Estonia</option>
        <option value="ET">Ethiopia</option>
        <option value="FK">Falkland Islands (Malvinas)</option>
        <option value="FO">Faroe Islands</option>
        <option value="FJ">Fiji</option>
        <option value="FI">Finland</option>
        <option value="FR">France</option>
        <option value="GF">French Guiana</option>
        <option value="PF">French Polynesia</option>
        <option value="GA">Gabon</option>
        <option value="GM">Gambia</option>
        <option value="GE">Georgia</option>
        <option value="DE">Germany</option>
        <option value="GH">Ghana</option>
        <option value="GI">Gibraltar</option>
        <option value="GR">Greece</option>
        <option value="GL">Greenland</option>
        <option value="GD">Grenada</option>
        <option value="GP">Guadeloupe</option>
        <option value="GU">Guam</option>
        <option value="GT">Guatemala</option>
        <option value="GN">Guinea</option>
        <option value="GW">Guinea-Bissau</option>
        <option value="GY">Guyana</option>
        <option value="HT">Haiti</option>
        <option value="HN">Honduras</option>
        <option value="HK">Hong Kong</option>
        <option value="HU">Hungary</option>
        <option value="IS">Iceland</option>
        <option value="IN">India</option>
        <option value="ID">Indonesia</option>
        <option value="IR">Iran</option>
        <option value="IQ">Iraq</option>
        <option value="IE">Ireland</option>
        <option value="IL">Israel</option>
        <option value="IT">Italy</option>
        <option value="JM">Jamaica</option>
        <option value="JP">Japan</option>
        <option value="JO">Jordan</option>
        <option value="KZ">Kazakhstan</option>
        <option value="KE">Kenya</option>
        <option value="KI">Kiribati</option>
        <option value="KR">Korea</option>
        <option value="KW">Kuwait</option>
        <option value="KG">Kyrgyzstan</option>
        <option value="LV">Latvia</option>
        <option value="LB">Lebanon</option>
        <option value="LS">Lesotho</option>
        <option value="LR">Liberia</option>
        <option value="LY">Libyan Arab Jamahiriya</option>
        <option value="LI">Liechtenstein</option>
        <option value="LT">Lithuania</option>
        <option value="LU">Luxembourg</option>
        <option value="MO">Macao</option>
        <option value="MK">Macedonia</option>
        <option value="MG">Madagascar</option>
        <option value="MW">Malawi</option>
        <option value="MY">Malaysia</option>
        <option value="MV">Maldives</option>
        <option value="ML">Mali</option>
        <option value="MT">Malta</option>
        <option value="MH">Marshall Islands</option>
        <option value="MQ">Martinique</option>
        <option value="MR">Mauritania</option>
        <option value="MU">Mauritius</option>
        <option value="YT">Mayotte</option>
        <option value="MX">Mexico</option>
        <option value="MD">Moldova</option>
        <option value="MC">Monaco</option>
        <option value="MN">Mongolia</option>
        <option value="MS">Montserrat</option>
        <option value="MA">Morocco</option>
        <option value="MZ">Mozambique</option>
        <option value="MM">Myanmar</option>
        <option value="NA">Namibia</option>
        <option value="NR">Nauru</option>
        <option value="NP">Nepal</option>
        <option value="NL">Netherlands</option>
        <option value="NC">New Caledonia</option>
        <option value="NZ">New Zealand</option>
        <option value="NI">Nicaragua</option>
        <option value="NE">Niger</option>
        <option value="NG">Nigeria</option>
        <option value="NU">Niue</option>
        <option value="NF">Norfolk Island</option>
        <option value="NO">Norway</option>
        <option value="OM">Oman</option>
        <option value="PK">Pakistan</option>
        <option value="PW">Palau</option>
        <option value="PS">Palestinian Territory</option>
        <option value="PA">Panama</option>
        <option value="PG">Papua New Guinea</option>
        <option value="PY">Paraguay</option>
        <option value="PE">Peru</option>
        <option value="PH">Philippines</option>
        <option value="PN">Pitcairn</option>
        <option value="PL">Poland</option>
        <option value="PT">Portugal</option>
        <option value="PR">Puerto Rico</option>
        <option value="QA">Qatar</option>
        <option value="RE">Reunion</option>
        <option value="RO">Romania</option>
        <option value="RU">Russian Federation</option>
        <option value="RW">Rwanda</option>
        <option value="SH">Saint Helena</option>
        <option value="KN">Saint Kitts and Nevis</option>
        <option value="LC">Saint Lucia</option>
        <option value="PM">Saint Pierre and Miquelon</option>
        <option value="VC">Saint Vincent and the Grenadines</option>
        <option value="WS">Samoa</option>
        <option value="SM">San Marino</option>
        <option value="ST">Sao Tome and Principe</option>
        <option value="SA">Saudi Arabia</option>
        <option value="SN">Senegal</option>
        <option value="SC">Seychelles</option>
        <option value="SL">Sierra Leone</option>
        <option value="SG">Singapore</option>
        <option value="SK">Slovakia</option>
        <option value="SI">Slovenia</option>
        <option value="SB">Solomon Islands</option>
        <option value="SO">Somalia</option>
        <option value="ZA">South Africa</option>
        <option value="ES">Spain</option>
        <option value="LK">Sri Lanka</option>
        <option value="SD">Sudan</option>
        <option value="SR">Suriname</option>
        <option value="SZ">Swaziland</option>
        <option value="SE">Sweden</option>
        <option value="CH">Switzerland</option>
        <option value="SY">Syrian Arab Republic</option>
        <option value="TW">Taiwan, Province of China</option>
        <option value="TJ">Tajikistan</option>
        <option value="TZ">Tanzania, United Republic of</option>
        <option value="TH">Thailand</option>
        <option value="TL">Timor-Leste</option>
        <option value="TG">Togo</option>
        <option value="TK">Tokelau</option>
        <option value="TO">Tonga</option>
        <option value="TT">Trinidad and Tobago</option>
        <option value="TN">Tunisia</option>
        <option value="TR">Turkey</option>
        <option value="TM">Turkmenistan</option>
        <option value="TC">Turks and Caicos Islands</option>
        <option value="TV">Tuvalu</option>
        <option value="UG">Uganda</option>
        <option value="UA">Ukraine</option>
        <option value="AE">United Arab Emirates</option>
        <option value="GB">United Kingdom</option>
        <option value="US">United States</option>
        <option value="UY">Uruguay</option>
        <option value="UZ">Uzbekistan</option>
        <option value="VU">Vanuatu</option>
        <option value="VE">Venezuela</option>
        <option value="VN">Viet Nam</option>
        <option value="WF">Wallis and Futuna</option>
        <option value="YE">Yemen</option>
        <option value="ZM">Zambia</option>
        <option value="ZW">Zimbabwe</option>
      </Form.Select>
    );
  }
}